import axios from 'axios';

axios.defaults.withCredentials = true;

export async function getReceipts(idcurso) {
  try {
    const response = await axios.post(`${import.meta.env.VITE_APP_API_URL}get-receipts`, { idcurso });
    return response

  } catch (error) {
    console.error('Error al obtener los recibos del alumno', error);
  }
}